import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import banner from './Images/banner.png';
import about from './Images/about.png';
import service from './Images/service.png';
import team from './Images/teammembers.png';
import features from './Images/calltoaction.png';
import testimonial from './Images/testimonial.png';


import "./Setting.css";
import HeaderBottom from '../../components/HomePage/HeaderBottom';

const SettingFour = () => {
    const [paypal, setPaypal] = useState([]);

    useEffect(() => {
        fetch(`https://aprilone-178ea8362c0b.herokuapp.com/paypal-email`)
            .then((res) => res.json())
            .then((info) => setPaypal(info));
    }, []);

    return (
        <>
         <HeaderBottom></HeaderBottom>
            <div className='setting-menu mb-5'>
                <div className="container text-center mb-5">
                    <div className="row justify-content-center mt-5 mb-5">
                        {/* Static Settings Links */}
                        
                            <div className='single-card  d-flex justify-content-center col-lg-3 col-md-5 col-sm-10  d-flex justify-content-center col-lg-3 col-md-5 col-sm-10'>
                                <Link to='/edit-banner-four'> 
                                    <img src={banner} alt="Banner" />
                                    <h6>Banner Setting</h6>
                                </Link>
                            </div>
    
                            <div className='single-card  d-flex justify-content-center col-lg-3 col-md-5 col-sm-10'>
                                <Link to='/edit-about-four'>  
                                    <img src={about} alt="About" /> 
                                    <h6>About Setting</h6> 
                                </Link>
                            </div>
                    
                            <div className='single-card  d-flex justify-content-center col-lg-3 col-md-5 col-sm-10'>
                                <Link to='/edit-service-four'> 
                                    <img src={service} alt="Service" /> 
                                    <h6>Service Setting</h6> 
                                </Link>
                            </div>
                     
                    
                    
                            <div className='single-card  d-flex justify-content-center col-lg-3 col-md-5 col-sm-10'>
                                <Link to='/edit-faq-four'>  
                                    <img src={team} alt="Counter" /> 
                                    <h6>FAQ Setting</h6>
                                </Link>
                            </div>
                           
                            <div className='single-card  d-flex justify-content-center col-lg-3 col-md-5 col-sm-10'>
                                <Link to='/edit-testimonial-four'>  
                                    <img src={testimonial} alt="Testimonial" />
                                    <h6>Testimonials</h6> 
                                </Link>
                            </div>
                            <div className='single-card  d-flex justify-content-center col-lg-3 col-md-5 col-sm-10'>
                                <Link to='/update-calltoaction'>  
                                    <img src={features} alt="Testimonial" />
                                    <h6>Call To Action</h6> 
                                </Link>
                            </div>
                    </div>
                </div>
            </div>
            <HeaderBottom />
        </>
    );
};

export default SettingFour;
